import React from 'react';
import { BoxProps, Flex, TextV2 } from '@withjoy/joykit';
import { MapMarker } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { milesToKm } from '@shared/utils/milesToMeters';
import { IMPERIAL_CULTURES } from '@shared/core/i18n/constants';

export interface DistanceFromVenueProps extends BoxProps {
  milesToVenue?: number | null;
  /** Size variant - affects font size */
  size?: 'sm' | 'md';
  useInterUI?: boolean;
  hasIcon?: boolean;
  iconSize?: number;
}

export const DistanceFromVenue: React.FC<DistanceFromVenueProps> = ({
  milesToVenue,
  color = 'mono10',
  size = 'md',
  useInterUI = true,
  hasIcon = false,
  iconSize = 16,
  ...props
}) => {
  const { t } = useTranslation('sharedComponents');
  const trans = t('distanceFromVenue');
  const culture = navigator.language.split('-')[1];
  const isImperial = IMPERIAL_CULTURES.includes(culture as typeof IMPERIAL_CULTURES[number]);

  if (!milesToVenue) {
    return null;
  }
  const distance = isImperial ? milesToVenue : milesToKm(milesToVenue);
  const fontSize = size === 'sm' ? pxToRem(13) : pxToRem(15);
  const typographyVariant = size === 'sm' ? 'label2' : 'body1';

  return (
    <Flex gap={2} alignItems="center" {...props}>
      {hasIcon && <MapMarker size={iconSize} />}
      <TextV2 typographyVariant={typographyVariant} fontSize={fontSize} color={color} {...(useInterUI && { fontFamily: 'Inter UI' })}>
        {isImperial ? trans.miles({ miles: distance.toFixed(2) }) : trans.kilometers({ km: distance.toFixed(2) })}
      </TextV2>
    </Flex>
  );
};
